import { render, staticRenderFns } from "./alfresco.vue?vue&type=template&id=007e9829&scoped=true&"
import script from "./alfresco.vue?vue&type=script&lang=js&"
export * from "./alfresco.vue?vue&type=script&lang=js&"
import style0 from "./alfresco.vue?vue&type=style&index=0&id=007e9829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007e9829",
  null
  
)

export default component.exports